import FinishIdentityProviderSignup from './FinishIdentityProviderSignup';

export default FinishIdentityProviderSignup;
